import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { products, productCategories } from '../../mockData';

export const FeaturedProductsSection = () => {
  const featuredProducts = products.filter(p => p.featured);

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <Badge className="mb-4 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black border-0 font-semibold">Featured Products</Badge>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Popular Beauty Instruments</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our most trusted luxury products used by beauty professionals worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {featuredProducts.slice(0, 8).map((product) => (
            <Card key={product.id} className="group cursor-pointer hover:shadow-xl transition-all duration-300 border-0 overflow-hidden">
              <div className="relative h-48 overflow-hidden bg-gray-100">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <Badge className="absolute top-3 right-3 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black border-0 font-semibold">
                  Featured
                </Badge>
              </div>
              <CardContent className="p-5">
                <Badge variant="outline" className="mb-3 text-xs">
                  {productCategories.find(c => c.id === product.category)?.name}
                </Badge>
                <h3 className="font-semibold text-base text-gray-900 mb-2 group-hover:text-yellow-700 transition-colors line-clamp-2">
                  {product.name}
                </h3>
                <p className="text-sm text-gray-600 mb-3 line-clamp-2">{product.description}</p>
                <Link to="/contact">
                  <Button size="sm" className="w-full bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 text-black font-semibold">
                    Request Quote
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/products">
            <Button size="lg" variant="outline" className="border-yellow-600 text-yellow-700 hover:bg-yellow-50">
              View All Products <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
